/**
 * 埋点分析SDK实例
 * 全局单例，供整个应用使用
 */

import AnalyticsSDK from './sdk'

// 🔧 [2025-11-19] SDK版本管理 - 自动清理旧版本缓存
const ANALYTICS_VERSION = '2.0.0'
const savedVersion = localStorage.getItem('analytics_version')

if (savedVersion !== ANALYTICS_VERSION) {
  // 清除旧版本的缓存数据(旧版本可能使用了错误的API路径)
  localStorage.removeItem('analytics_event_queue')
  localStorage.removeItem('analytics_heatmap_queue')
  // 注意: 不清除 analytics_consent,保留用户的同意状态
  localStorage.setItem('analytics_version', ANALYTICS_VERSION)
  console.log(`[Analytics] 已从版本${savedVersion || '未知'}升级到${ANALYTICS_VERSION},旧缓存已清除`)
}

// 创建全局实例
const analytics = new AnalyticsSDK({
  apiUrl: '/api/v1/analytics-events/events',
  batchApiUrl: '/api/v1/analytics-events/events/batch',
  heatmapApiUrl: '/api/v1/analytics-events/heatmap/data',
  heatmapBatchApiUrl: '/api/v1/analytics-events/heatmap/data/batch',
  batchSize: 10,          // 每批10个事件
  batchInterval: 5000,    // 5秒上报一次
  maxRetry: 3,            // 最多重试3次
  enableHeatmap: true,    // 启用热力图
  sampleRate: 0.2         // 热力图采样率20%
})

// 导出实例
export default analytics

// 导出便捷方法
export const track = (eventName, eventCategory, eventData, options) => {
  return analytics.track(eventName, eventCategory, eventData, options)
}

export const pageView = (pageUrl, options) => {
  return analytics.pageView(pageUrl, options)
}

export const buttonClick = (buttonName, eventData) => {
  return analytics.buttonClick(buttonName, eventData)
}

export const formSubmit = (formName, eventData) => {
  return analytics.formSubmit(formName, eventData)
}

export const apiCall = (apiName, eventData) => {
  return analytics.apiCall(apiName, eventData)
}

